import { useFiltersSyncWithUrl } from "@/shared/hooks/use-dynamic-filters-sync";
import { useControlFiltersStore } from "../stores/control-filters.store";

const urlKeys = {
  associatedTags: "tags",
  resultCount: "result",
  amount: "stake",
} as const;

export function useControlFiltersSync() {
  const filtersStore = useControlFiltersStore();

  const { columnFilters, setColumnFilters, globalFilter, setGlobalFilter } =
    useFiltersSyncWithUrl({
      filtersStore,
      urlKeys,
      numericColumns: ["amount"],
      rangeColumns: ["amount"],
    });

  return {
    columnFilters,
    setColumnFilters,
    globalFilter,
    setGlobalFilter,
  };
}
